module.exports = __webpack_public_path__ + "img/dian.2db0bb0c.png";